import $ from "jquery";
import jQueryUJSInit from "jquery-ujs";

const jQuery = $;
window.$ = $;
window.jQuery = $;

// Prevent double initialization of jquery-ujs
if ($.rails == undefined) {
  jQueryUJSInit(jQuery);
}

document.addEventListener("turbo:load", function () {
  $(".datepicker").datepicker({
    format: "yyyy",
    language: "sv",
    autoclose: true,
    viewMode: 2,
    minViewMode: 2,
  });

  $(".datepicker-full").datepicker({
    format: "yyyy-mm-dd",
    language: "sv",
    autoclose: true,
  });

  $(window).bind("load resize", function () {
    if ($(this).width() < 769) {
      $("body").addClass("body-small");
    } else {
      $("body").removeClass("body-small");
    }
  });

  // FIX FOR POSITIONING DROPDOWN OUTSIDE OVERFLOW AUTO CONTAINER
  //
  $(".dropdown").on("show.bs.dropdown", function () {
    $(".dropdown-container").removeClass("dropdown-container");
    $(".table-responsive").css("overflow", "hidden");
    $(".flowx-hidden").removeClass("flowx-hidden");
    $(".flowx-auto").removeClass("flowx-auto").addClass("flowx-hidden");
    $(this).parent().addClass("dropdown-container");

    // To ensure other elements do not move around when the dropdown is
    // moved in the DOM, the hack below creates an invisible copy of the
    // element being moved. This will act as a spacer, keeping all other
    // elements in place until the original is moved back.
    var placeholder = $(this).clone();
    placeholder.addClass("__dropdown-placeholder");
    placeholder.find(".dropdown-menu").remove();
    placeholder.css({
      visibility: "hidden",
    });

    $(this).addClass("active-dropdown");
    $("body").append(
      $(".active-dropdown")
        .css({
          position: "absolute",
          top: $(".active-dropdown").offset().top,
          left: $(".active-dropdown").offset().left,
        })
        .detach()
    );

    $(".dropdown-container").append(placeholder);
  });

  $(".dropdown").on("hidden.bs.dropdown", function () {
    resetDropdown();
  });

  // Prevent dropdown from closing when clicking on the name or email
  $(".nav > .non-mobile-only > .popover-container > .popover-header").on(
    "click",
    function (e) {
      e.stopPropagation();
    }
  );

  $(window).on("resize", function () {
    if ($(".active-dropdown").hasClass("open")) {
      $(".dropdown").removeClass("open");
      $(".dropdown").trigger("click");
      resetDropdown();
    }
  });

  function resetDropdown() {
    $(".table-responsive").css("overflow", "");
    $(".flowx-hidden").removeClass("flowx-hidden").addClass("flowx-auto");
    $(".__dropdown-placeholder").remove();
    $(".dropdown-container").append(
      $(".active-dropdown")
        .css({ position: "relative", top: "initial", left: "initial" })
        .removeClass("active-dropdown")
        .detach()
    );
  }
});

export default jQuery;
